import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LandingPage from './components/LandingPage';
import LegalDocumentPage from './components/LegalDocumentPage';
import TermsOfServiceContent from './components/TermsOfServiceContent';
import PrivacyPolicyContent from './components/PrivacyPolicyContent';
import MedicalDisclaimerContent from './components/MedicalDisclaimerContent';
import CrispChat from './components/CrispChat';
import LocaleSync from './components/LocaleSync';
import {
  FoodsHub,
  GuidesHub,
  MealPlansHub,
  RecipesHub,
  FoodRoute,
  GuideRoute,
  MealPlanRoute,
  RecipeRoute,
} from './pages/knowledgeRoutes';
import { LANG_META, normalizeLang } from './lib/contentLocale';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function HtmlLang() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = LANG_META[normalizeLang(i18n.language)].html;
  }, [i18n.language]);
  return null;
}

const knowledgeLeaves = [
  ['foods', FoodsHub],
  ['foods/:slug', FoodRoute],
  ['guides', GuidesHub],
  ['guides/:slug', GuideRoute],
  ['meal-plans', MealPlansHub],
  ['meal-plans/:slug', MealPlanRoute],
  ['recipes', RecipesHub],
  ['recipes/:slug', RecipeRoute],
];

const PrivacyPage = () => {
  const { t } = useTranslation();
  return (
    <LegalDocumentPage title={t('footer.privacy') || 'Privacy Policy'}>
      <PrivacyPolicyContent />
    </LegalDocumentPage>
  );
};

const TermsPage = () => {
  const { t } = useTranslation();
  return (
    <LegalDocumentPage title={t('footer.terms') || 'Terms of Service'}>
      <TermsOfServiceContent />
    </LegalDocumentPage>
  );
};

const DisclaimerPage = () => {
  const { t } = useTranslation();
  return (
    <LegalDocumentPage title={t('footer.disclaimer') || 'Medical Disclaimer'}>
      <MedicalDisclaimerContent />
    </LegalDocumentPage>
  );
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <HtmlLang />
          <LocaleSync />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            {knowledgeLeaves.map(([path, Component]) => (
              <Route key={path} path={`/${path}`} element={<Component />} />
            ))}
            {['uk', 'ro'].flatMap((lang) =>
              knowledgeLeaves.map(([path, Component]) => (
                <Route
                  key={`${lang}-${path}`}
                  path={`/${lang}/${path}`}
                  element={<Component />}
                />
              ))
            )}
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
          </Routes>
          <CrispChat />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
